class SearchTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.search__tab');

    this.productPanel = this.querySelector('#tab-product-panel');
    this.pagePanel = this.querySelector('#tab-page-panel');
    this.articlePanel = this.querySelector('#tab-article-panel');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
    });
  }

  handleTabClick(e) {
    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', false);
    });

    e.target.setAttribute('aria-selected', true);

    if (e.target.dataset.tab === 'product') {
      this.productPanel.classList.remove('hidden');
      this.pagePanel.classList.add('hidden');
      this.articlePanel.classList.add('hidden');
    } else if (e.target.dataset.tab === 'page') {
      this.productPanel.classList.add('hidden');
      this.pagePanel.classList.remove('hidden');
      this.articlePanel.classList.add('hidden');
    } else if (e.target.dataset.tab === 'article') {
      this.productPanel.classList.add('hidden');
      this.pagePanel.classList.add('hidden');
      this.articlePanel.classList.remove('hidden');
    }
  }
}

customElements.define('search-tabs', SearchTabs);
